
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Globals } from 'src/app/globals';
import { User, Doctor } from '../modal/user';


@Injectable({
    providedIn: 'root'
})

export class DoctorService {
    constructor(private httpclient: HttpClient, private global: Globals) {
        console.log(this.global.loggedUser.token);
    }

    findByUsedReferalcode(referalcode) {
        let headers: HttpHeaders = new HttpHeaders();
        headers = headers.append('Authorization', "Bearer " + this.global.loggedUser.token);
        return this.httpclient.get<User>(this.global.G_apiUrl + "/userRegistration/findbyuserreferalcode/" + `${referalcode}`, {headers: headers });
  }  
  searchToAndFromDate(todate,fromdate,referalcode){
    let headers: HttpHeaders = new HttpHeaders();
    headers = headers.append('Authorization', "Bearer " + this.global.loggedUser.token);
    return this.httpclient.get<User>(this.global.G_apiUrl + "/userRegistration/findbyuserreferalcodetofromdate/" + `${todate}/`+ `${fromdate}/`+ `${referalcode}`, {headers: headers });
  }

  createHealthCard(id,type) {
    let headers: HttpHeaders = new HttpHeaders();
    headers = headers.append('Authorization', "Bearer " + this.global.loggedUser.token);
    return this.httpclient.post<User>(this.global.G_apiUrl + "/userRegistration/createHealthCardForAdmin/" + id+"/"+type, { headers: headers });
}
updateHealthCardRefferalText(id, healthcardtext) {
    let headers: HttpHeaders = new HttpHeaders();
    headers = headers.append('Authorization', "Bearer " + this.global.loggedUser.token);
    return this.httpclient.post(this.global.G_apiUrl + "/userRegistration/updateHealthCardIssuedRefferalText/", {
        'user_reg_id': id,
        'healthCardIssuedText': healthcardtext.hcRefferalText,
        'healthCardBackSideText': healthcardtext.hcBackSideText,
    },
        { responseType: "text", headers: headers });
}
getCreateNewSubscribeStatus(userid){
    let headers: HttpHeaders = new HttpHeaders();
    headers = headers.append('Authorization', "Bearer " + this.global.loggedUser.token);
    return this.httpclient.get<Doctor>(this.global.G_apiUrl + "/userRegistration/getCreateNewSubscribeStatus/" + userid, { headers: headers });
}
  
}  